import React from "react";

export default function LayerCaution({itemNumber}) {

    return(
        <>
            {itemNumber === '76709' &&
                <>
                    <li>
                        <span>ㆍ</span><strong>기본 조립 서비스 (1대분)</strong> 옵션을 선택하지 않으시면, 견적에 포함된 부품만 발송됩니다.
                    </li>
                    <li>
                        <span>ㆍ</span>견적에 포함된 부품이 <strong>2대 이상</strong>인 경우, 옵션도 <strong>동일한 수량으로 구매</strong>하셔야 합니다.
                    </li>
                    <li>
                        <span>ㆍ</span>제대로 작동하는지 더욱 정확하게 테스트한 후 발송을 원하면, 반드시 <strong>정품 운영체제 구매</strong> 및 <strong>운영체제 설치 서비스 (1대분)</strong> 옵션을 선택하셔야 합니다.
                    </li>
                </>
            }

            {/*프리미엄 기본 조립 일 경우 주의사항 내용*/}

            {itemNumber === '11275005' &&
                <>
                    <li>
                        <span>ㆍ</span><strong>프리미엄 조립 서비스 (1대분)</strong> 옵션을 선택하지 않으시면, 견적에 포함된 부품만 발송됩니다.
                    </li>
                    <li>
                        <span>ㆍ</span>견적에 포함된 부품이 <strong>2대 이상</strong>인 경우, 옵션도 <strong>동일한 수량으로 구매</strong>하셔야 합니다.
                    </li>
                    <li>
                        <span>ㆍ</span>제대로 작동하는지 더욱 정확하게 테스트한 후 발송을 원하면, 반드시 <strong>정품 운영체제 구매</strong> 및 <strong>운영체제 설치 서비스 (1대분)</strong> 옵션을 선택하셔야 합니다.
                    </li>
                </>
            }
            {itemNumber === '1154496' &&
                <>
                    <li>
                        <span>ㆍ</span><strong>기본 조립 + 1년 전국 출장 A/S (1대분)</strong> 옵션을 선택하지 않으시면, 견적에 포함된 부품만 발송됩니다.
                    </li>
                    <li>
                        <span>ㆍ</span>견적에 포함된 부품이 <strong>2대 이상</strong>인 경우, 옵션도 <strong>동일한 수량으로 구매</strong>하셔야 합니다.
                    </li>
                    <li>
                        <span>ㆍ</span>제대로 작동하는지 더욱 정확하게 테스트한 후 발송을 원하면, 반드시 <strong>정품 운영체제 구매</strong> 및 <strong>운영체제 설치 서비스 (1대분)</strong> 옵션을 선택하셔야 합니다.
                    </li>
                </>
            }
            {itemNumber === '10995920' &&
                <>
                    <li>
                        <span>ㆍ</span><strong>기본 조립 + 2년 전국 출장 A/S (1대분)</strong> 옵션을 선택하지 않으시면, 견적에 포함된 부품만 발송됩니다.
                    </li>
                    <li>
                        <span>ㆍ</span>견적에 포함된 부품이 <strong>2대 이상</strong>인 경우, 옵션도 <strong>동일한 수량으로 구매</strong>하셔야 합니다.
                    </li>
                    <li>
                        <span>ㆍ</span>제대로 작동하는지 더욱 정확하게 테스트한 후 발송을 원하면, 반드시 <strong>정품 운영체제 구매</strong> 및 <strong>운영체제 설치 서비스 (1대분)</strong> 옵션을 선택하셔야 합니다.
                    </li>
                </>
            }
            {itemNumber === '11275006' &&
                <>
                    <li>
                        <span>ㆍ</span><strong>프리미엄 조립 + 1년 전국 출장 A/S (1대분)</strong> 옵션을 선택하지 않으시면, 견적에 포함된 부품만 발송됩니다.
                    </li>
                    <li>
                        <span>ㆍ</span>견적에 포함된 부품이 <strong>2대 이상</strong>인 경우, 옵션도 <strong>동일한 수량으로 구매</strong>하셔야 합니다.
                    </li>
                    <li>
                        <span>ㆍ</span>제대로 작동하는지 더욱 정확하게 테스트한 후 발송을 원하면, 반드시 <strong>정품 운영체제 구매</strong> 및 <strong>운영체제 설치 서비스 (1대분)</strong> 옵션을 선택하셔야 합니다.
                    </li>
                </>
            }
            {itemNumber === '11275007' &&
                <>
                    <li>
                        <span>ㆍ</span><strong>프리미엄 조립 + 2년 전국 출장 A/S (1대분)</strong> 옵션을 선택하지 않으시면, 견적에 포함된 부품만 발송됩니다.
                    </li>
                    <li>
                        <span>ㆍ</span>견적에 포함된 부품이 <strong>2대 이상</strong>인 경우, 옵션도 <strong>동일한 수량으로 구매</strong>하셔야 합니다.
                    </li>
                    <li>
                        <span>ㆍ</span>제대로 작동하는지 더욱 정확하게 테스트한 후 발송을 원하면, 반드시 <strong>정품 운영체제 구매</strong> 및 <strong>운영체제 설치 서비스 (1대분)</strong> 옵션을 선택하셔야 합니다.
                    </li>
                </>
            }
            {itemNumber === '11653042' &&
                <>
                    <li>
                        <span>ㆍ</span>전문 기사가 직접 방문하여 조립PC를 설치해 드리는 서비스로, <strong>현장 조립 서비스를 제공하지 않습니다.</strong>
                    </li>
                    <li>
                        <span>ㆍ</span><strong>최대 본체 1대와 모니터 2대까지 연결</strong>해 드리며, 추가 요청사항이 있을 경우 <strong>별도의 요금이 발생할 수
                        있습니다.</strong>
                    </li>
                    <li>
                        <span>ㆍ</span>방문 일정 조율을 위해 전문 기사가 별도로 연락을 드립니다. 단, <strong>출장 설치가 불가능한 지역의 경우 서비스가 어려울 수
                        있습니다.</strong>
                    </li>
                </>
            }
            {itemNumber === '1099800' &&
                <>
                    <li>
                        ㆍ행복쇼핑에 입점해 있는 모든 미니샵은 정품이 아닌 불법 소프트웨어 설치를 하지 않습니다.
                    </li>
                    <li>
                        ㆍ정품 운영체제를 구매하지 않거나, 운영체제 설치서비스를 선택하지 않으면 운영체제는
                        설치되지 않은 상태로 발송됩니다.
                    </li>
                </>
            }
        </>
    )
}



// WEBPACK FOOTER //
// ./src/estimate_list/components/estimate/service/serviceAsseblyLayer/layerCaution/layerCaution.js